import { Component } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import {
  ItemsPerPageChanged,
  OrderingChanged,
  PagingChanged,
  SortingChanged,
} from 'src/app/shared/actions/paginator.actions';
import { Paginator } from 'src/app/shared/models/grid.model';
import { BreakpointFacadeService } from 'src/app/shared/services/breakpoint.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { EliquaFacadeService } from '../../services/eliqua.facade.service';
import { PaginatorLiteralsFacadeService } from '../../services/literals/paginator.literals.facade.service';
import {
  NewLiteralsPagingChanged,
  NewLiteralsPerPageChanged,
} from 'src/app/modules/administration/locale-management/actions/import-export-literals.actions';
import {
  LiteralsPagingChanged,
  LiteralsPerPageChanged,
} from 'src/app/modules/administration/locale-management/actions/search-literals.actions';

@Component({
    selector: 'dragonfly-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
    standalone: false
})
export class PaginatorComponent {
  constructor(
    public paginatorLiterals: PaginatorLiteralsFacadeService,
    public paginatorFacadeService: PaginatorFacadeService,
    public breakpointFacadeService: BreakpointFacadeService,
    public eliquaFacadeService: EliquaFacadeService,
  ) {}

  onItemsChange(itemsNumber: number) {
    if (this.eliquaFacadeService.activeComponent === 'ImportExportLiteralsComponent') {
      this.paginatorFacadeService.dispatch(NewLiteralsPerPageChanged({ itemsNumber }));
    } else if (this.eliquaFacadeService.activeComponent === 'LiteralsSearchComponent') {
      this.paginatorFacadeService.dispatch(LiteralsPerPageChanged({ itemsNumber }));
    } else this.paginatorFacadeService.dispatch(ItemsPerPageChanged({ itemsNumber }));
  }

  onOrderChange(selection: any) {
    const selectedOrder: string = selection.innerText as string;
    this.paginatorFacadeService.dispatch(OrderingChanged({ selectedOrder }));
  }

  onSortChange(selection: any) {
    const selectedSortField: string = selection.innerText as string;
    this.paginatorFacadeService.dispatch(SortingChanged({ selectedSortField }));
  }

  pagingChanged(e: PageEvent) {
    const paginator = e as Paginator;
    if (this.eliquaFacadeService.activeComponent === 'ImportExportLiteralsComponent') {
      this.paginatorFacadeService.dispatch(NewLiteralsPagingChanged({ paginator }));
    } else if (this.eliquaFacadeService.activeComponent === 'LiteralsSearchComponent') {
      this.paginatorFacadeService.dispatch(LiteralsPagingChanged({ paginator }));
    } else this.paginatorFacadeService.dispatch(PagingChanged({ paginator }));
  }
}
